module.exports = __webpack_public_path__ + "40d111581ea7054a1627744dcef7b529.MP3";